<div class="fx-row fx-wrap justify-content-between">
  <div class="fx-row align-items-center justify-content-start">
    <app-back></app-back>
  </div>
  <div class="fx-row align-items-center justify-content-between fx-flex-100">
    <div class="fx-row align-items-center justify-content-between  fx-flex-100">
      <div class="fx-row align-items-center justify-content-start">
        <span class="page-title" *ngIf="case">{{case.identifier || case.reference}}</span>
        <div class="chip mb-10 ml-10" [class.red]="case?.state == 'CLOSED'" [class.green]="case?.state == 'OPENED'">
          {{'CASE.PHASE_'+case?.state | translate}}</div>
      </div>
      <div class="fx-flex fx-row align-items-center justify-content-end">
        <button [cdkMenuTriggerFor]="menu" class="button ml-20 mb-10" *ngIf="mode === 'CONSULTATION'">
          <div class="fx-row align-items-center justify-content-between fx-flex-100">
            <span class="dark fx-flex">{{'ACTIONS.ACTIONS' | translate}}</span>
            <mat-icon class="dark ml-5" fontSet="material-icons-outlined">arrow_drop_down</mat-icon>
          </div>
        </button>
        <ng-template #menu>
          <mat-card class="menu-container p-0 elevation" style="max-width:180px;" cdkMenu>
            <div class="fx-column">
              <div class="fx-row align-items-center justify-content-between menu-item actionable clickable"
                (click)="openEvidenceRecordGenerationDialog()">
                <mat-icon class="dark mr-5" fontSet="material-icons-outlined">folder_special</mat-icon>
                <span class="text fx-flex">{{'CASE.GENERATE_EVIDENCE_RECORD' | translate}}</span>
              </div>
              <mat-divider></mat-divider>
              <div class="fx-row align-items-center justify-content-start menu-item actionable clickable" cdkMenuItem
                aclBasedElement (click)="updateCaseState()" resource="CASE" [scopes]="['U']">
                <mat-icon class="dark mr-5" fontSet="material-icons-outlined">schedule</mat-icon>
                <span class="text fx-flex">{{(case?.state == 'OPENED' ? 'CASE.ACTION_CLOSE' : 'CASE.ACTION_OPEN')
                  | translate}}</span>
              </div>
              <mat-divider *ngIf="possibleActions.length > 0"></mat-divider>
              <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                (click)="canUpdate() ? openEditMode() : null" [class.disabled]="!canUpdate()" cdkMenuItem
                aclBasedElement resource="CASE" [scopes]="['U']">
                <mat-icon class="dark mr-5" [class.light]="!canUpdate()"
                  fontSet="material-icons-outlined">edit</mat-icon>
                <span class="text fx-flex" [class.light]="!canUpdate()">{{'ACTIONS.EDIT' | translate}}</span>
              </div>
              <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                (click)="delete()" cdkMenuItem aclBasedElement resource="CASE" [scopes]="['D']">
                <mat-icon class="red mr-5" fontSet="material-icons-outlined">delete</mat-icon>
                <span class="text fx-flex">{{'ACTIONS.DELETE' | translate}}</span>
              </div>
            </div>
          </mat-card>
        </ng-template>
        <button class="button ml-20" *ngIf="mode === 'EDITION'" (click)="mode = 'CONSULTATION'">
          {{'ACTIONS.CANCEL' | translate}}
        </button>
        <button class="main-button ml-10" *ngIf="mode === 'EDITION'" (click)="update()">
          {{'ACTIONS.SAVE_CHANGES' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="mt-20" *ngIf="case"
  (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedIndex" #caseTabs>
  <mat-tab>
    <ng-template mat-tab-label class="text">
      {{'CASE.TAB_INFORMATION' | translate}}
    </ng-template>
    <div class="mt-20">
      <app-case-information [case]="case" [count]="count" [propertyOffice]="propertyOffice" [mode]="mode"
        (toProofs)="selectedIndex = 1" [trademarkProductsServices]="trademarkProductsServices"
        [productsServices]="productsServices" #caseInformation></app-case-information>
    </div>
  </mat-tab>
  <mat-tab *ngIf="case.type !== CaseType.RENEWAL_MAINTENANCE">
    <ng-template mat-tab-label class="text">
      {{'CASE.TAB_PROOFS' | translate}}
      <div class="chip main plain ml-5" *ngIf="case && count > 0">
        {{count}}
      </div>
    </ng-template>
    <div class="mt-20">
      <app-case-proofs [case]="case" (refresh)="onRefresh()" [readonly]="case.state === 'CLOSED'"
        [trademarkProductsServices]="trademarkProductsServices" [productsServices]="productsServices"
        [relevantTerritories]="relevantCountries" #caseProofs></app-case-proofs>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label class="text">
      {{'CASE.TAB_'+(case.type !== CaseType.RENEWAL_MAINTENANCE ? 'EVIDENCE_RECORDS' : 'GENERATED_FILES') | translate}}
    </ng-template>
    <div class="mt-20">
      <app-case-evidence-records [case]="case" (reviewPendingDocuments)="reviewPendingDocuments()"
        #caseEvidenceRecords></app-case-evidence-records>
    </div>
  </mat-tab>
  <mat-tab *ngIf="case.type !== CaseType.RENEWAL_MAINTENANCE">
    <ng-template mat-tab-label class="text">
      {{'CASE.TAB_ATTACHMENTS' | translate}}
      <div class="badge ml-5" *ngIf="numberOfAttachments > 0">
        <span class="white small bold">{{numberOfAttachments}}</span>
      </div>
    </ng-template>
    <div class="mt-20">
      <app-case-attachments [case]="case" (refresh)="onRefresh()" [readonly]="case.state !== 'CLOSED'"
        #caseAttachments></app-case-attachments>
    </div>
  </mat-tab>
  <mat-tab *ngIf="case.type !== CaseType.RENEWAL_MAINTENANCE">
    <ng-template mat-tab-label class="text">
      {{'CASE.TAB_NOTES' | translate}}
      <div class="badge ml-5" *ngIf="case && case.notes && case.notes.length > 0">
        <span class="white small bold">{{case.notes.length}}</span>
      </div>
    </ng-template>
    <div class="mt-20">
      <app-case-notes [case]="case" #caseNotes></app-case-notes>
    </div>
  </mat-tab>
  <mat-tab *ngIf="isManagerOrAbove">
    <ng-template mat-tab-label class="text">
      {{'CASE.TAB_USERS' | translate}}
    </ng-template>
    <div class="mt-20">
      <app-case-users [case]="case" #caseUsers></app-case-users>
    </div>
  </mat-tab>
</mat-tab-group>